import { BranchRouting, BranchRoutingBreadcrumbs } from "../branch/branch.routing";
import { CustomFromRouting, CustomFromRoutingBreadcrumbs } from "../custom-form/custom-form.router";
import { EmployeeBillingRouting, EmployeeBillingRoutingBreadcrumbs } from "../employeebilling/employeebilling.routing";
import { EmployeeDetailsRouting, EmployeeDetailsRoutingBreadcrumbs } from "../employeedetails/employeedetails.routing";
import { GuestRouting, GuestRoutingBreadcrumbs } from "../guest/guest.routing";
import { HolidayComponent } from "../holiday-pattern/holiday.component";
import { NotificationsComponent } from "../notifications/notifications.component";
import { ParkingRouting, ParkingRoutingBreadcrumbs } from "../parking/parking.routing";
import { ShiftRouter, ShiftRoutingBreadcrumbs } from "../shift/shift.router";
import { TransportOrganizationComponent } from "./transport-organization.component";
import { UsersRouting } from '../users/users.routing';
import { EscortDetailsRouting, EscortDetailsRoutingBreadcrumbs } from "../escort/escort.routing";
import { GlobalSettingsComponent } from "../global-settings/global-settings.component";
import { GlobalSettingsRouting } from "../global-settings/global-settings.routing";
import { LocationRouting, LocationRoutingBreadcrumbs } from "../location/location.routing";
import { GeofenceRouting, GeofenceRoutingBreadcrumbs } from "../geofence/geofence.routing";
import { GeoLocationRouting, GeoLocationRoutingBreadcrumbs } from "../geolocation/geolocation.routing";
import { ZoneRouting, ZoneRoutingBreadcrumbs } from "../zone/zone.routing";

export const TransportOrganizationRouting = [
    { path: '', component: TransportOrganizationComponent },
    { path: 'employee', children: EmployeeDetailsRouting },
    { path: 'employee-billing', children: EmployeeBillingRouting },
    { path: 'guest', children: GuestRouting },
    { path: 'shift', children: ShiftRouter },
    { path: 'branch', children: BranchRouting },
    { path: 'zone', children: ZoneRouting },
    { path: 'geolocation', children: GeoLocationRouting },
    { path: 'parking', children: ParkingRouting },
    { path: 'notification', component: NotificationsComponent },
    { path: 'holiday', component: HolidayComponent },
    { path: 'custom-form', children: CustomFromRouting },
    { path: 'users', children: UsersRouting },
    { path: 'escort', children: EscortDetailsRouting },
    { path: 'global-settings', children: GlobalSettingsRouting }, //component:GlobalSettingsComponent }
    { path: 'location', children: LocationRouting },
    { path: 'geofence', children: GeofenceRouting }
];

export const TransportOrganizationRoutingBreadcrumbs = [
    { name: 'Organization', path: '' },
    { name: 'Employee', path: '/employee', children: EmployeeDetailsRoutingBreadcrumbs },
    { name: 'Employee-Billing', path: '/employee-billing', children: EmployeeBillingRoutingBreadcrumbs },
    { name: 'Guest', path: '/guest', children: GuestRoutingBreadcrumbs },
    { name: 'Shift', path: '/shift', children: ShiftRoutingBreadcrumbs },
    { name: 'Branch', path: '/branch', children: BranchRoutingBreadcrumbs },
    { name: 'Zone', path: '/zone', children: ZoneRoutingBreadcrumbs },
    { name: 'Parking', path: '/parking', children: ParkingRoutingBreadcrumbs },
    { name: 'Notification', path: '/notification' },
    { name: 'Holiday', path: '/holiday' },
    { name: 'Custom-Form', path: '/custom-form', children: CustomFromRoutingBreadcrumbs },
    { name: 'Escort', path: '/escort', children: EscortDetailsRoutingBreadcrumbs },
    { name: 'Location', path: '/location', children: LocationRoutingBreadcrumbs },
    { name: 'Geofence', path: '/geofence', children: GeofenceRoutingBreadcrumbs },
    { name: 'Geo-Location', path: '/geolocation', children: GeoLocationRoutingBreadcrumbs }

];
